import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'
import $ from 'jquery'

import UiStore from 'stores/UiStore'

import { sitewideSearchSuggestions } from 'config'

import styles from './styles-embeddedsearch.scss'

export class SuggestionsCycler extends Component {
  restart () {
    let $list = $(this.refs.suggestionList)
    window.requestAnimationFrame(() => {
      $list.children().css('animation-name', 'none')
      window.requestAnimationFrame(() => {
        $list.children().css('animation-name', '')
      })
    })
  }

  render () {
    const { animationDuration, pretext, suggestions } = this.props

    return h.div(h.ca(styles.suggestionContainer),
      h.p(h.ca(styles.pretext), pretext),
      h.div({
        ref: 'suggestionList',
        ...h.ca(styles.suggestionList)
      },
        suggestions.map((suggestion, i) => (
          h.p({
            key: i,
            style: {
              animationDelay: `${i * animationDuration}ms`
            },
            onAnimationEnd: () => {
              if (i === suggestions.length - 1) {
                this.restart()
              }
            },
            ...h.ca(styles.suggestion)
          }, suggestion)
        ))
      )
    )
  }
}

@observer(['UiStore'])
export default class EmbeddedSearchBar extends Component {
  onKeyPress (e) {
    if (e.key === 'Enter') {
      // There is some odd bug when using browserHistory.push() which causes
      // the landing page to flicker over the top of the search results page
      // when using it (see #537). This is a hacky workaround to avoid that
      // problem. We would much rather find a better solution, but this is a
      // workaround until such a solution can be found.
      const url = `/search?search=${UiStore.sitewideSearchFilters.search}`
      window.location.href = url
    }
  }

  render () {
    const { UiStore, pretext } = this.props

    return h.div(h.ca(styles.container),
      UiStore.sitewideSearchFilters.search === '' && h.h(SuggestionsCycler, {
        animationDuration: 4000,
        pretext,
        suggestions: sitewideSearchSuggestions
      }),
      h.input({
        ...h.ca(styles.input),
        ref: 'input',
        value: UiStore.sitewideSearchFilters.search,
        onChange: ev => { UiStore.sitewideSearchFilters.search = ev.target.value },
        onKeyPress: ::this.onKeyPress,
        name: 'Sitewide Search'
      }),
      h.icon({
        ...h.ca(styles.icon),
        name: 'search'
      })
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/EmbeddedSearchBar.js